import { FC } from 'react';
import feeNote from 'images/feeNote.svg';

const HomeIcon: FC = (props): JSX.Element => {
  return <img src={feeNote} alt="fee-note-icon" />;
};
export default HomeIcon;
